<template>
  <div :style="style" ref="tableContainer">
    <table :style="table.style">
        <tr v-for="(row,index) in table.rows" :key="index">
            <td v-for="(col,childrenindex) in row" :key="childrenindex" :style="col.style" :colspan="col.colspan" :rowspan="col.rowspan">
              <CktextComponent :rawHtml="col.data"></CktextComponent>
            </td>
        </tr>
    </table>
  </div>
  
</template>

<script>
import CktextComponent from '../CkText.vue';

export default {
  name: 'TableComponent',
  components: {
    CktextComponent
  },
  data(){
    return {
      table:'',
      style:''
    }
  },
  props: {
    component: null
  },
  methods:{
    generateStyle(style){

      return this.$common.generateStyle(style);

    }
  },
  created(){
    
    this.style=this.generateStyle(this.component.data.style);

    this.table=this.component.data.data;

    this.table.style=this.$common.generalStyle(this.table.style);

    for(var i=0; i<this.table.rows.length; i++){

      for(var j=0; j<this.table.rows[i].length; j++)
        this.table.rows[i][j].style=this.$common.generalStyle(this.table.rows[i][j].style);

    }

  },
  mounted(){

    const table_container_width=this.$refs.tableContainer.clientWidth-6; //this.$refs.tableContainer.style.width;

    if(table_container_width>0)
    for(var i=0; i<this.table.rows.length; i++){

      for(var j=0; j<this.table.rows[i].length; j++)
      {

        this.table.rows[i][j].style+='max-width:'+table_container_width+'px';

      }

    }

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  table{
    width: 100%;
    border-collapse: collapse;
  }
  td{
      padding: 8px;
      min-width: 50px;
  }
</style>
